/** Empty initial state — all content is loaded from GET /api/public/bootstrap */

export const DEFAULT_CONTACT = {
  hero: { title: '', subtitle: '' },
  panel: {},
  form: {},
  office: { name: '', address: '' },
  email: '',
  phone: '',
  socials: { facebook: '#', twitter: '#', linkedin: '#', youtube: '#' },
  map: { location: '' },
};

export const normalizeContact = (contact) => ({
  ...DEFAULT_CONTACT,
  ...(contact || {}),
  hero: { ...DEFAULT_CONTACT.hero, ...(contact?.hero || {}) },
  office: { ...DEFAULT_CONTACT.office, ...(contact?.office || {}) },
  socials: { ...DEFAULT_CONTACT.socials, ...(contact?.socials || {}) },
  map: { ...DEFAULT_CONTACT.map, ...(contact?.map || {}) },
});

export const EMPTY_BOOTSTRAP_STATE = {
  cars: [],
  modified_cars: [],
  car_projects: [],
  brands: [],
  model: [],
  body_type: [],
  fuel_type: [],
  transmission: [],
  seats: [],
  car_color: [],
  featuers: [],
  partners: [],
  sub_register: [],
  state: [],
  city: [],
  carousel: [],
  heroType: [],
  ads: null,
  home_page: { cardLimit: 8, sections: [] },
  contact: { ...DEFAULT_CONTACT },
  privacy: {},
  aboutUs: {},
  whychooseus: [],
  appPromo: {
    title: '',
    subtitle: '',
    description: '',
    storeButtons: [],
    phoneImage: '',
  },
  auth: { pages: {}, roles: [] },
  header: { logo: {}, navItems: [], auth: {}, megaMenu: {}, search: {} },
  profile: { tabs: [], sections: {}, kycForm: {}, profileFields: [], passwordSettings: {} },
  sellcar_form: [],
  sellcar_page: {},
  valuation_page: {},
  valuation_form: [],
  compare_page: {},
  car_trust: {},
  emi_page: {},
  warranty_page: {},
  adminContact: null,
  user: null,
};

export const mergeBootstrapState = (mapped = {}) => ({
  ...EMPTY_BOOTSTRAP_STATE,
  ...mapped,
  home_page: { ...EMPTY_BOOTSTRAP_STATE.home_page, ...(mapped.home_page || {}) },
  contact: normalizeContact(mapped.contact),
  auth: { ...EMPTY_BOOTSTRAP_STATE.auth, ...(mapped.auth || {}) },
  header: { ...EMPTY_BOOTSTRAP_STATE.header, ...(mapped.header || {}) },
  profile: { ...EMPTY_BOOTSTRAP_STATE.profile, ...(mapped.profile || {}) },
  sellcar_page: { ...EMPTY_BOOTSTRAP_STATE.sellcar_page, ...(mapped.sellcar_page || {}) },
  valuation_page: { ...EMPTY_BOOTSTRAP_STATE.valuation_page, ...(mapped.valuation_page || {}) },
  compare_page: { ...EMPTY_BOOTSTRAP_STATE.compare_page, ...(mapped.compare_page || {}) },
  car_trust: { ...EMPTY_BOOTSTRAP_STATE.car_trust, ...(mapped.car_trust || {}) },
  emi_page: { ...EMPTY_BOOTSTRAP_STATE.emi_page, ...(mapped.emi_page || {}) },
  warranty_page: { ...EMPTY_BOOTSTRAP_STATE.warranty_page, ...(mapped.warranty_page || {}) },
  appPromo: { ...EMPTY_BOOTSTRAP_STATE.appPromo, ...(mapped.appPromo || {}) },
  aboutUs: { ...EMPTY_BOOTSTRAP_STATE.aboutUs, ...(mapped.aboutUs || {}) },
});
